<template>
    <BaseLoader :loader="loader" />

<base-dialog :show="error != null" :showCloseIcon="false" title="Something Fishy" @close="error == null">
        <template v-slot:content>                  
                <div class="inv-wrapper nwd-wrap">
                    <div class="inv-form-item">
                            <label>{{error}}</label>    
                    </div>
                </div>
        </template>
            <template v-slot:actions>
                <base-button class="app-icon large-btn" @click="error=null" title="Close">
                        <app-icon icon="hugeicons:cancel-square" width="18" />
                </base-button>                      
        </template>
</base-dialog>

<base-dialog :show="showDialog" :title="dialogTitle" @close="closeDialog" :windowWidth="880">
    <template v-slot:content>
        <!-- Tab Navigation -->
        <div class="tab-navigation">
            <button 
                class="tab-button" 
                :class="{ active: activeTab === 'tab-1' }"
                @click="activeTab = 'tab-1'"
            >
                <app-icon icon="hugeicons:user-account" width="18" />
                <span>Campaign Info</span>
            </button>
            <button 
                class="tab-button" 
                :class="{ active: activeTab === 'tab-2' }"
                @click="activeTab = 'tab-2'"
            >
                <app-icon icon="hugeicons:database-setting" width="18" />
                <span>Campaign Tags</span>
            </button>
            <button 
                class="tab-button" 
                :class="{ active: activeTab === 'tab-3' }"
                @click="activeTab = 'tab-3'"
            >
                <app-icon icon="hugeicons:school-report-card" width="18" />
                <span>Campaign Assets</span>
            </button>
        </div>

        <!-- Tab Content -->
        <div class="dialog-form tab-1" v-show="activeTab === 'tab-1'">
            <div class="form-row">
                <div class="form-group">
                    <label class="form-label">Client</label>
                    <vue-select
                        class="form-input-select" 
                        :key="selectKey"
                        v-model="dialogData.ClientId" 
                        :options="clientList" 
                        label-by="Name"
                        value-by="Id"                      
                        clear-on-close 
                        close-on-select  /> 
                </div>  
                <div class="form-group">
                    <label class="form-label">Campaign Name</label>
                    <input type="text" v-model="dialogData.CampaignName" class="form-input">
                </div>    
                
            </div>
            
            <div class="form-row">
                <div class="form-group">
                    <label class="form-label">Date from</label>
                    <vue-datepicker 
                        v-model="dialogData.DateFrom"                        
                        :teleport="true"
                        auto-apply
                        required
                        :format="formatDate"
                        model-type="yyyy-MM-dd HH:mm"
                        :min-date="new Date()"
                        @update:model-value="handleDateFromChange" />
                </div>
                <div class="form-group">
                    <label class="form-label">Date to</label>
                    <vue-datepicker 
                        v-model="dialogData.DateTo"                        
                        :teleport="true"
                        auto-apply
                        required
                        :format="formatDate"
                        model-type="yyyy-MM-dd HH:mm"
                        :min-date="dialogData.DateFrom || new Date()" />
                </div>
            </div>

            <div class="billing-section">
                <span class="billing-section-label">
                    <app-icon icon="hugeicons:money-bag-02" width="13" />
                    Billing
                </span>
                <div class="form-row">
                    <div class="form-group">
                        <label class="form-label">Billing Model</label>
                        <vue-select 
                            class="form-input-select"
                            v-model="dialogData.BillingModelId" 
                            :key="selectKey"
                            :options="campaignBillingModelDict" 
                            label-by="Model" 
                            value-by="Id"                      
                            clear-on-close 
                            close-on-select  /> 
                    </div>

                    <div class="form-group">
                        <label class="form-label">Overall budget <span class="l-case">[pln]</span></label>
                        <input type="number" v-model="dialogData.OverallBudget" class="form-input">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label class="form-label">Cost per view <span class="l-case">[gr]</span> <span class="l-case" v-if="dialogData.BillingModelId == 1">/ sec.</span></label>
                        <input type="number" v-model="dialogData.CostPerView" class="form-input input-50" min="0" step="0.01">
                        <input v-if="dialogData.BillingModelId == 1" type="number" v-model="dialogData.ViewTime" class="form-input input-50" min="0" step="0.01">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Target views <span class="l-case" v-if="dialogData.BillingModelId == 1">/ sec.</span></label>
                        <input type="number" v-model="calculatedTargetViews" class="form-input readonly-input" readonly tabindex="-1">
                    </div>                
                </div>
            </div>
            
            <div class="form-row">                
                <div class="form-group form-group-full">
                    <label class="form-label">Campaign Status</label>
                    <vue-select
                        class="form-input-select" 
                        :key="selectKey"
                        v-model="dialogData.CampaignStatusId" 
                        :options="campaignStatusToEdit" 
                        label-by="Status"
                        value-by="Id"                      
                        clear-on-close 
                        close-on-select  /> 
                </div>                    
            </div>                
            
            
        </div>
        <div class="dialog-form tab-2" v-show="activeTab === 'tab-2'">
            <div>
                <p class="small-inf">{{ selectedStreamersCount }} Streamers selected</p>
            </div>
            <div class="tag-manager">
                                    
                <p class="form-label">Tags</p>
                <div v-if="selectedTagsObjects.length" class="chips-container">
                    <div 
                        v-for="tag in selectedTagsObjects" 
                        :key="tag.Id" 
                        :class="[{ 'chip': true, 'all-tag': tag.Id == 1 }]"
                    >
                        {{ tag.Tag }}
                        <span class="remove-icon" @click="removeTag(tag.Id)">&times;</span>
                    </div>
                </div>
                <div v-else>
                    <p class="small-inf">No tags selected</p>
                </div>

                <div v-if="dialogData.CampaignStatusId === 1" class="input-group">
                    <label class="form-label" for="tag-select">New tag:</label>
                    <vue-select 
                        id="tag-select"
                        class="form-input-select tag-select"
                        v-model="selectedTagToAdd" 
                        :options="remainingTags" 
                        label-by="Tag"
                        value-by="Id"
                        placeholder="Select a tag..."
                        :disabled="remainingTags.length === 0"
                        @update:modelValue="handleTagSelect"
                        searchable
                        clear-on-close   
                                            
                    />
                </div>
                
                <div v-else class="input-group">
                    <p class="small-inf">Campaign is not in Draft status. Cannot add tags.</p>
                </div>
                
            </div>


        </div>
        <div class="dialog-form tab-3" v-show="activeTab === 'tab-3'">
            <div class="asset-assignment-manager">
                <div class="assignment-header">
                    <p class="form-label">Campaign Formats & Assets</p>
                    <button v-if="dialogData.CampaignStatusId === 1" @click="addAssetAssignment" 
                            :class="{ 'spec-btn add-btn': true, 'disabled': dialogData.CampaignStatusId !== 1 }"
                            title="Add Format/Asset" 
                            :disabled="dialogData.CampaignStatusId !== 1">
                        <app-icon icon="hugeicons:add-01" width="18" />
                        <span>Add New</span>
                    </button>

                    <div v-if="dialogData.CampaignStatusId !== 1" class="abs-info">
                        <p class="small-inf">Campaign is not in Draft status. Cannot edit assets.</p>
                    </div>
                </div>

                <div v-if="dialogData.CampaignAssets && dialogData.CampaignAssets.length" class="assignment-list">
                    <div 
                        v-for="(assignment, index) in dialogData.CampaignAssets" 
                        :key="index" 
                        :class="{'assignment-row': true, 'disabled': dialogData.CampaignStatusId !== 1}"
                    >
                        <div :class="{'selected-asset-preview': true, 'no-preview': !assignment.AssetId}">
                            <div v-if="assignment.AssetId">
                                <img v-if="getAssetPath(assignment.AssetId).Type === 'image'" :src="getAssetPath(assignment.AssetId).Path" alt="">
                                <video v-else :src="getAssetPath(assignment.AssetId).Path" autoplay loop muted></video>
                            </div>
                            <div class="no-preview" v-else>
                                <app-icon icon="hugeicons:image-01" width="24" />
                            </div>
                        </div>
                        
                        <div class="form-group format-select">
                            <label class="form-label">Format</label>
                            <vue-select
                                class="form-input-select vue-select thin format-select" 
                                v-model="assignment.FormatId" 
                                :options="formats" 
                                label-by="Name"
                                value-by="Id"     
                                :disabled="dialogData.CampaignStatusId !== 1"                 
                                placeholder="Select format..."
                                @update:modelValue="assignment.AssetId = null"
                                clear-on-close 
                                close-on-select  /> 
                        </div>

                        <div class="form-group asset-select">
                            <label class="form-label">Asset</label>
                            <vue-select
                                class="form-input-select vue-select thin format-select" 
                                v-model="assignment.AssetId" 
                                :options="getFilteredAssets(assignment.FormatId)" 
                                :label-by="(option) => option.FolderName + '/' + option.UserFileName"
                                value-by="Id"
                                teleport="body"                           
                                :disabled="!assignment.FormatId || dialogData.CampaignStatusId !== 1"
                                placeholder="Select asset..."
                                clear-on-close 
                                :maxHeight="150"
                                @update:modelValue="(newId) => handleAssetSelect(assignment, newId)"
                                close-on-select  /> 
                        </div>

                        <div class="form-group number-input">
                            <label class="form-label small-label">Next Check</label>
                            <input 
                                type="number" 
                                v-model="assignment.NextCheckSec" 
                                class="form-input"
                                placeholder="0"
                                :disabled="dialogData.CampaignStatusId !== 1"
                                min="0" />
                        </div>

                        <div class="form-group number-input" v-if="assignment.AssetId && getAssetPath(assignment.AssetId).Type === 'image'">
                            <label class="form-label small-label">Disp.Duration</label>
                            <input 
                                type="number" 
                                v-model="assignment.DisplayDurationSec" 
                                class="form-input"
                                placeholder="0"
                                :disabled="dialogData.CampaignStatusId !== 1"
                                min="0" />
                        </div>



                        <div class="form-group number-input" v-if="assignment.AssetId && getAssetPath(assignment.AssetId).Type === 'video'">
                            <label class="form-label small-label">Play Count</label>
                            <input 
                                type="number" 
                                v-model="assignment.PlayCount" 
                                class="form-input"
                                placeholder="0"
                                :disabled="dialogData.CampaignStatusId !== 1"
                                min="0" />
                        </div>

                        <button @click="removeAssetAssignment(index)" 
                                :disabled="dialogData.CampaignStatusId !== 1"
                                :class="{ 'app-icon delete-btn': true, 'btn-disabled': dialogData.CampaignStatusId !== 1 }"
                                title="Remove">
                            <app-icon icon="hugeicons:delete-03" width="14" height="12" />
                        </button>
                    </div>
                </div>
                <div v-else class="empty-assignments">
                    <p class="small-inf">No assets assigned to this campaign.</p>
                </div>
            </div>
        </div>
    </template>
    <template v-slot:actions>
        <div :class="['actions-result', { error: onSaveError }]">
            {{ onSaveResult }}
        </div>
        <base-button class="app-icon large-btn" @click="closeDialog" title="Close">
            <app-icon icon="hugeicons:cancel-square" width="18" />
        </base-button>     
        <base-button class="app-icon icon-blue large-btn" @click="saveCampaign" title="Save">
            <app-icon icon="hugeicons:floppy-disk" width="18" />
        </base-button>             
    </template>
</base-dialog>



  <div class="admin-container">
    <NaviPanel />

    <main class="main-layout">
      <NaviHeader />

      <div class="content-scroll">

         <div class="cs-card">
            <h3>Campaign list</h3>
            <p class="text-tooltip">Campaigns dictionary. Manage campaigns and assign banner formats with related assets.</p>

            <button class="spec-btn refresh-btn" @click="campaignList" title="Refresh">
                <app-icon icon="hugeicons:refresh-dot" width="18" />
            </button>
         </div>
         
        <div class="cs-card cs-animation">            

            <div class="cs-filter">
                <div class="filter-item">
                    <label for="status">Status</label>
                  
                    <vue-select 
                        :key="selectKey"
                        v-model="selectedStatus" 
                        :options="campaignStatusDict" 
                        label-by="Status"
                        value-by="Id"
                        class="vue-select thin"
                        @update:modelValue="campaignList"                         
                        clear-on-close 
                        close-on-select  />   
                </div>
                
                <div class="filter-item filter-item-btn">
                    <span class="filter-label">New Campaign</span>
                    <button @click="dialogModeBtnClick(0,'new')" class="app-icon"><app-icon icon="hugeicons:credit-card-add" width="18" /></button>
                </div>
            </div>

            
            <div class="center-pan">
                    <vue-good-table
                        :columns="table1columns"
                        :rows="table1rows"
                        :line-numbers="false"
                        :search-options="{enabled: true}"
                        :sort-options="{enabled: true}"
                        :pagination-options="{
                                enabled: true,
                                mode: 'records'
                        }" 
                                    
                    >
                        <template v-slot:emptystate>
                        No data
                        </template>

                        <template v-slot:table-row="props">
                                <div v-if="props.column.field == 'Action'">
                                            <button title="Edit" class="app-icon" :name="props.row.Id" @click="dialogModeBtnClick(props.row.Id, 'edit')"><app-icon icon="hugeicons:chat-edit-01" width="18" /></button>
                                            <button title="Change status" class="app-icon icon-blue" :name="props.row.Id" @click="changeStatus(props.row.Id)"><app-icon icon="hugeicons:card-exchange-01" width="18" /></button>
                                </div>
                                <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </span>
                        </template>
                        
                    </vue-good-table>
            </div>  
        </div>      

      </div>
    </main>
  </div>
</template>


<script>
    import NaviPanel from '@/components/NaviPanel.vue';
    import NaviHeader from '@/components/NaviHeader.vue';
    import BaseLoader from '@/components/BaseLoader.vue';

    import shared from "@/shared";
    import apiService from "@/services/other.js";

    export default {
        components: { NaviPanel, NaviHeader, BaseLoader},
        name: 'CampaignsView',

        data: function () {
            return {
                loader: false,
                error: null, 
                onSaveError: false,
                onSaveResult: '',               
                table1columns: [
                  {
                  label: 'Campaign Id',
                  field: 'Id',
                  tdClass: 'text-f14'
                  },
                  {
                  label: 'Campaign Name',
                  field: 'CampaignName',
                  tdClass: 'text-f14'
                  },
                  {
                  label: 'Client Name',
                  field: 'ClientName',
                  tdClass: 'text-f12'
                  },
                  {
                  label: 'Date From',
                  field: 'DateFrom',
                  tdClass: 'text-f12'
                  },
                  {
                  label: 'Date To',
                  field: 'DateTo',
                  tdClass: 'text-f14'
                  },
                  {
                  label: 'Streamers No',
                  field: 'StreamerNo',
                  tdClass: 'text-f14'
                  },
                  {
                  label: 'Status',
                  field: 'CampaignStatus',
                  tdClass: 'text-f14'
                  },
                  {
                  label: '',
                  field: 'Action',
                  tdClass: 'text-center',
                  sortable: false,
                  width: '128px',
                  }
                ],
                activeTab: 'tab-1',
                table1rows: [],               
                campaignStatusDict: [],
                campaignStatusToEdit: [],
                campaignBillingModelDict: [],
                allAvailableTags: [],
                selectedTagIds: [1],
                selectedTagToAdd: null,  
                selectedStreamers: [],  
                clientList: [],
                selectedStatus: -1,
                selectKey: 0,
                showDialog: false,
                dialogMode: 'new',
                dialogTitle: 'New Campaign',
                dialogData: {},
                formats: [], 
                assets: [],
            };
        },
        created() {      
            this.formatDate = shared.formatDate;   
                 
        },

        mounted() {
            this.campaignList();
            this.statusDict();
            this.billingModelDict();
            this.streamerAttributesList();
            this.clientDict();
            this.assetsList();
            this.formatList();
        },

        computed: {
            // Wylicza Target Views: budżet [pln] / koszt za wyświetlenie [gr]
            // calculatedTargetViews() {
            //     const budget = parseFloat(this.dialogData.OverallBudget);
            //     const cpv = parseFloat(this.dialogData.CostPerView);
            //     if (!this.dialogData.BillingModelId || this.dialogData.BillingModelId === -1) return '';
            //     if (!budget || !cpv || cpv === 0) return '';
            //     return Math.floor((budget * 100) / cpv);
            // },

            calculatedTargetViews: {
                get() {
                const budget = parseFloat(this.dialogData.OverallBudget);
                const cpv = parseFloat(this.dialogData.CostPerView);

                if (!this.dialogData.BillingModelId || this.dialogData.BillingModelId === -1) return '';
                if (!budget || !cpv || cpv === 0) return '';

                return Math.floor((budget * 100) / cpv);
                },
                set(value) {
                this.dialogData.TargetViews = value;
                }
            },

            // Zwraca pełne obiekty tagów na podstawie wybranych ID
            selectedTagsObjects() {
                return this.allAvailableTags.filter(tag => 
                    this.selectedTagIds.includes(tag.Id)
                );
            },
            // Zwraca tagi, których użytkownik jeszcze NIE wybrał
            remainingTags() {
                return this.allAvailableTags.filter(tag => 
                    !this.selectedTagIds.includes(tag.Id)
                );
            },

            selectedStreamersCount() {
                return this.selectedStreamers.length;
            }
        },

        methods: {   

            campaignList() {
            
                this.loader = true;
                const data = {ResultName: "campaignList",
                    CampaignStatus: this.selectedStatus === null ? -1 : this.selectedStatus
                };
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            this.table1rows = response.data;  

                            console.log(this.table1rows);
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '301', true, e))
                    .finally(() => {
                        this.loader = false;
                    });
            },

            clientDict() {

                this.loader = true;
                const data = {ResultName: "clientList"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            //this.clientList = response.data;  
                            const options = [{ Id: -1, Name: '-Select-' }, ...response.data];
                            this.clientList = options;

                            console.log(this.clientList);
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '302', true, e))
                    .finally(() => {
                        this.loader = false;
                    });
            },

            statusDict() {
            
                this.loader = true;
                const data = {ResultName: "campaignStatusDict"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            this.campaignStatusToEdit = response.data;
                        
                            const options = [{ Id: -1, Status: '-All-' }, ...response.data];
                            this.campaignStatusDict = options;
                            
                            this.selectedStatus = -1;
                            this.selectKey++

                            //console.log(this.streamerStatusDict);

                    }
                    })
                    .catch((e) => shared.handleError.call(this, '303', true, e))
                    .finally(() => {
                        this.loader = false;
                    });
            },

            billingModelDict() {
            
                this.loader = true;
                const data = {ResultName: "billingModelDict"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
 
                            const options = [{ Id: -1, Model: '-Select-' }, ...response.data];
                            this.campaignBillingModelDict = options;
                            this.selectKey++;                      

                    }
                    })
                    .catch((e) => shared.handleError.call(this, '304', true, e))
                    .finally(() => {
                        this.loader = false;
                    });

                console.log('campaignBillingModelDict');
                console.log(this.campaignBillingModelDict);
            },


            closeDialog() {
                this.showDialog = false;
                this.dialogMode = 'new';
                this.dialogTitle = 'New Campaign';
                this.dialogData = {};
                this.activeTab = 'tab-1'; // Reset to first tab
            },

            dialogModeBtnClick(id, mode) {
                this.dialogMode = mode;
                this.showDialog = true;

                if (mode == 'new') {
                    this.dialogData.Id = 0;
                    this.dialogData.CampaignName = '';
                    this.dialogData.ClientName = '';
                    this.dialogData.ClientId = -1;
                    this.dialogData.DateFrom = '';
                    this.dialogData.DateTo = '';
                    this.dialogData.CampaignStatus = '';
                    this.dialogData.CampaignStatusId = 1;
                    this.dialogData.CampaignAssets = [];
                    this.dialogData.BillingModelId = -1;
                    this.dialogData.CostPerView = 0;
                    this.dialogData.ViewTime = 0;
                    this.dialogData.OverallBudget = 0;
                    this.dialogData.TargetViews = 0;
                    this.selectedTagIds = [1];
                }
                else {
                    this.dialogTitle = 'Edit Campaign';
                    const row = this.table1rows.find(item => item.Id === id);
                    this.dialogData = { ...row };

                    const attributeIds = (this.dialogData.Attributes ?? []);     
  
                    this.selectedTagIds = attributeIds;

                    this.showStreamersFromTags();
                   
                    console.log('dialogData');
                    console.log(this.dialogData);
                    console.log('selectedTagIds');
                    console.log(this.selectedTagIds);

                }
               
            },  

            streamerAttributesList() {
                const data = {ResultName: "streamerAttributesDict"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {     

                        this.allAvailableTags = [
                            { Id: 1, Tag: '-All-' },
                            ...response.data
                        ];
                        //console.log(this.allAvailableTags);                        

                    }
                    })
                    .catch((e) => shared.handleError.call(this, '305', true, e));
            },

            handleTagSelect(tagId) {
                if (tagId) {
                    this.addTag(tagId);
                    // Clear selection after adding
                    this.selectedTagToAdd = null;

                    this.showStreamersFromTags();
                }
            },
            addTag(id) {
                if (id === 1) {
                    this.selectedTagIds = [1];
                } 
                
                else {
                    this.selectedTagIds = this.selectedTagIds.filter(tagId => tagId !== 1);
                    if (!this.selectedTagIds.includes(id)) {
                        this.selectedTagIds.push(id);
                    }
                }
            },
            removeTag(id) {
                this.selectedTagIds = this.selectedTagIds.filter(tagId => tagId !== id);
                this.showStreamersFromTags();
            },

            showStreamersFromTags() {

                const data = {ResultName: "showStreamersFromTags", SelectedTagIds: this.selectedTagIds};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {     

                        this.selectedStreamers = response.data;
                        console.log('selectedStreamers');      
                        console.log(this.selectedStreamers);                    

                    }
                    })
                    .catch((e) => shared.handleError.call(this, '307', true, e));


                
            },

            saveCampaignConsole() {
                console.log('saveCampaignConsole');
                console.log(this.dialogData);
            },


            saveCampaign() {
              
                this.dialogData.CampaignAssets = this.dialogData.CampaignAssets.filter(
                    a => a.FormatId != null && a.AssetId != null
                );

                if (this.dialogMode === 'new') {
                    this.dialogData.ResultName = "campaignAdd";
                }
                else {
                    this.dialogData.ResultName = "campaignEdit";
                }

                this.dialogData.TargetViews = this.calculatedTargetViews;

                const data = this.dialogData;                
                data.SelectedTagIds = this.selectedTagIds;

                console.log(data);

                if (data.CampaignAssets.length == 0 || data.SelectedTagIds.length == 0) {
                    this.onSaveError = true;                        
                    this.onSaveResult = 'No assets or tags selected.';
                }
                else {
                    console.log('Saving campaign');

                    
                    apiService
                        .uniExec(data)
                        .then((response) => {
                        if (response.status === 200 && response.data.success) {                  
                            
                            this.onSaveError = false;
                            this.onSaveResult = 'Excellent! Campaign saved successfully.';
                            setTimeout(() => {
                                this.onSaveResult = '';
                                this.showDialog = false;
                                this.campaignList();
                            }, 2000);

                        }
                        else {
                            this.onSaveError = true;                        
                            this.onSaveResult = 'Code(306a): '+response.data.text;
                        }
                        })
                        .catch((e) => shared.handleError.call(this, '306', true, e));
                }

            },

            

            handleDateFromChange(newVal) {
                if (!newVal) return;

                if (this.dialogData.DateTo && newVal > this.dialogData.DateTo) {
                    this.dialogData.DateTo = null;
                }
            },

            formatList() {
                const data = {ResultName: "bannerList"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                        if (response.status === 200) {                  
                            this.formats = response.data;  
                            this.selectKey++;
                            console.log(this.formats);
                        }
                    })
                    .catch((e) => shared.handleError.call(this, '308', true, e));
            },

            assetsList() {
            
                const data = {ResultName: "assetsList"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            this.assets = response.data;  
                            console.log(this.assets);
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '309', true, e));
            },

            getFilteredAssets(formatId) {
                if (!formatId) return [];
                return this.assets.filter(asset => asset.FormatId === formatId);
            },

            handleAssetSelect(assignment, assetId) {
                if (!assetId) return;

                const asset = this.assets.find(a => a.Id === assetId);
                if (!asset || asset.Type !== 'video') return;

                // Pobierz długość wideo przez tymczasowy element <video>
                const video = document.createElement('video');
                video.preload = 'metadata';
                video.onloadedmetadata = () => {
                    if (isFinite(video.duration) && video.duration > 0) {
                        assignment.DisplayDurationSec = Math.ceil(video.duration);
                    }
                    video.src = '';
                };
                video.src = asset.Path;
            },

            addAssetAssignment() {
                if (!this.dialogData.CampaignAssets) {
                    this.dialogData.CampaignAssets = [];
                }
                this.dialogData.CampaignAssets.push({
                    FormatId: null,
                    AssetId: null,
                    NextCheckSec: 0,
                    DisplayDurationSec: 0,
                    PlayCount: 0
                });

                console.log('CampaignAssets');
                console.log(this.dialogData.CampaignAssets);
            },

            removeAssetAssignment(index) {
                this.dialogData.CampaignAssets.splice(index, 1);
            },

            getAssetPath(assetId) {
                // if (!assetId) return '';
                // const asset = this.assets.find(a => a.Id === assetId);
                // return asset ? asset.Path : '';
                if (!assetId) return null;
                return this.assets.find(a => a.Id === assetId) || null;
            },

            changeStatus(id) {

                const data = {ResultName: "campaignStatusChange", CampaignId: id};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200 && response.data.success) {                  
                            
                            this.campaignList();

                    }
                    else {
                        this.error = 'Code(310a): '+response.data.text;
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '310', true, e));
                
            },

        }

    }
</script>



<style>

.asset-assignment-manager {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px 5px;
}

.assignment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--border);
    padding-bottom: 10px;
    position: relative;
}

.assignment-header .form-label {
    margin-bottom: 0 !important;
    font-size: 16px;
    font-weight: 600;
}

.abs-info {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0px;
}

.add-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 16px !important;
    font-size: 13px;
    font-weight: 600;
}

.add-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.add-btn.disabled span {
    color: var(--text-muted);
}



.assignment-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.assignment-list .number-input .form-input {
    padding: 6px 10px;
    font-size: 12px;
}

.assignment-row {
    display: flex;
    gap: 15px;
    align-items: flex-end;
    padding: 10px 16px;
    background: var(--bg-page);
    border: 1px solid var(--border);
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
}

.assignment-row .delete-btn {
    position: absolute;
    top: 6px;
    right: 4px;
    padding: 2px 2px 0px 2px;
}

.assignment-row:hover {
    border-color: var(--blue);
    background: rgba(102, 126, 234, 0.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    /* transform: translateY(-2px); */
}

.assignment-row.disabled:hover {
    border-color: var(--red);
}

.format-select, .asset-select {
    flex: 1;
}

.number-input {
    flex: 0 0 120px;
}

.format-select .form-label, .asset-select .form-label, .number-input .form-label {
    margin-bottom: 6px;
    font-size: 12px;
    opacity: 0.8;
}

.number-input .form-input {
    padding: 8px 10px;
    font-size: 13px;
}

.delete-btn {
    padding: 4px 4px 2px 4px;
}

.selected-asset-preview {
    width: 58px;
    height: 58px;
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: 8px;
    overflow: hidden;
    display: flex;    
    align-items: normal;
    justify-content: center;
    flex-shrink: 0;
}

.selected-asset-preview.no-preview {
    align-items: center;
}

.selected-asset-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.selected-asset-preview video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.selected-asset-preview .no-preview {
    color: var(--text-muted);
    opacity: 0.3;
}

/* .delete-btn:hover {
    background: rgba(255, 71, 87, 0.1);
    transform: scale(1.1);
} */

.empty-assignments {
    text-align: center;
    padding: 48px;
    background: rgba(0, 0, 0, 0.015);
    border: 2px dashed var(--border);
    border-radius: 12px;
    color: var(--text-muted);
}

.empty-assignments p {
    font-style: italic;
    font-size: 14px;
}

.assigment-row .form-input-select {
    padding: 0px !important;
}

.readonly-input {
    background: var(--bg-page, #f5f5f5) !important;
    opacity: 0.75;
    cursor: not-allowed;
    border-style: dashed !important;
    color: var(--text-muted, #888) !important;
    font-style: italic;
}

.billing-section {
    position: relative;
    border: 1px solid rgba(102, 126, 234, 0.35);
    border-radius: 8px;
    padding: 18px 16px 12px;
    background: rgba(102, 126, 234, 0.04);
    margin-bottom: 4px;
}

.billing-section-label {
    position: absolute;
    top: -10px;
    left: 14px;
    background: var(--bg-card, #fff);
    padding: 0 8px;
    font-size: 11px;
    font-weight: 600;
    color: rgba(102, 126, 234, 0.85);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
}

.billing-section .form-row:last-child {
    margin-bottom: 0;
}

/* input-50: dwa inputy obok siebie gdy oba widoczne, jeden input na 100% gdy tylko jeden */
.form-group:has(.input-50) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.form-group:has(.input-50) .form-label {
    flex-basis: 100%;
    margin-bottom: 0;
}

.input-50 {
    flex: 1;
    min-width: 0;
}

</style>